import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';

//Servicios
import { LogService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import DJCELogs from './DJCELogs';

function DJCELogsContainer({}) {
    const { token, masters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.DJCELogsPage, [state.DJCELogsPage]);
    const [loader, setLoader] = useState(false);
    const [tablePages, setTablePages] = useState();

    const Params = useParams();

    useEffect(() => {
        const getDJCELogsCuantity = async () => {
            try {
                setLoader(true);

                const DJCELogsCuantity = await LogService.totalRecords({
                    token,
                    objeto: 5,
                    objeto_id: parseInt(Params.id),
                });

                if (DJCELogsCuantity) setTablePages(DJCELogsCuantity.data);

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        const getDJCELogs = async () => {
            try {
                setLoader(true);

                const DJCELogs = await LogService.byObject({
                    token,
                    objeto: 5,
                    objeto_id: parseInt(Params.id),
                    pagina: tablePage,
                    cantidad: tableData.pagination,
                });

                if (DJCELogs) {
                    setTableData(buildTableData(DJCELogs.data));
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getDJCELogsCuantity();
        getDJCELogs();
    }, [tablePages, tablePage]);

    const buildTableData = (data = []) => {
        return {
            headers: ['Fecha', 'Hora', 'Responsable', 'Nivel', 'Acción'],
            tablePages,
            pagination: 10,
            pageType: 'DJCELogsPage',
            data:
                data.length > 0
                    ? data?.map((log) => {
                          return {
                              fecha: dayjs(log.fecha).format('DD-MM-YYYY'),
                              hora: dayjs(log.fecha).format('HH:mm:ss'),
                              responsable: `${log.apellido}, ${log.nombre}`,
                              nivel: masters.UserTypes?.find(
                                  (m) => m.id === log.tipo
                              )?.nombre,
                              accion: masters.AccionTypes?.find(
                                  (at) => at.id === log.accion
                              ).nombre.replace(/_/g, ' '),
                          };
                      })
                    : [],
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? <Spinner /> : <DJCELogs tableData={tableData} />;
}

export default DJCELogsContainer;
